module.exports = __webpack_public_path__ + "static/media/Orladeyo_Logo-v1.1.17f04f60.png";